/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Createdby1Inputs */

const de__field_createdby1 = /** @type {(inputs: _Field_Createdby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`angelegt von`)
};

/**

* @param {_Field_Createdby1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_createdby1 = /** @type {((inputs?: _Field_Createdby1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Createdby1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_createdby1(inputs)
});
export { _field_createdby1 as "_field_createdBy" }